import { ColDef } from 'ag-grid-community';
import { dateFormatter, dateTimeFormatter } from 'src/app/shared/functions';


export const DriversLicenseTableColumnDef: ColDef[] = [
  {// ID
    headerName: 'ID',
    field: 'id',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
    hide: true,
  },
  {// Drivers License ID
    headerName: 'Drivers License ID',
    field: 'driversId',
    resizable: true,
    width: 175,
    filter: 'agTextColumnFilter',
  },
  {// Name
    headerName: 'Name',
    colId: 'name',
    valueGetter: (params) => `${params.data.nameFirst} ${params.data.nameLast.charAt(0)}.`,
    resizable: true,
    filter: 'agTextColumnFilter',
    flex: 1,
  },
  {// Birthdate.
    headerName: 'Birthdate',
    field: 'birthDate',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
  },
  {// Gender
    headerName: 'Gender',
    field: 'gender',
    resizable: true,
    width: 125,
    filter: 'agTextColumnFilter',
  }
];